// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/common/currency.proto
/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal.js";
import { CurrencyCode } from "./currency_codes.js";
// For Node.js to access named exports from CommonJS
const __m0 = 'default' in _m0 ? _m0.default : _m0;
export const protobufPackage = "squareup.common";
function createBaseMoney() {
    return { $type: "squareup.common.Money", amount: undefined, currencyCode: undefined };
}
export const Money = {
    $type: "squareup.common.Money",
    encode(message, writer = __m0.Writer.create()) {
        const unregisterLong = registerLong();
        try {
            if (message.amount !== undefined) {
                writer.uint32(16).int64(message.amount);
            }
            if (message.currencyCode !== undefined) {
                writer.uint32(24).int32(message.currencyCode);
            }
            return writer;
        }
        finally {
            unregisterLong();
        }
    },
    decode(input, length) {
        const unregisterLong = registerLong();
        try {
            const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
            let end = length === undefined ? reader.len : reader.pos + length;
            const message = createBaseMoney();
            while (reader.pos < end) {
                const tag = reader.uint32();
                switch (tag >>> 3) {
                    case 2:
                        if (tag !== 16) {
                            break;
                        }
                        message.amount = longToNumber(reader.int64());
                        continue;
                    case 3:
                        if (tag !== 24) {
                            break;
                        }
                        message.currencyCode = reader.int32();
                        continue;
                }
                if ((tag & 7) === 4 || tag === 0) {
                    break;
                }
                reader.skipType(tag & 7);
            }
            return message;
        }
        finally {
            unregisterLong();
        }
    },
    create(base) {
        return Money.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMoney();
        message.amount = object.amount ?? undefined;
        message.currencyCode = object.currencyCode ?? undefined;
        return message;
    },
};
function longToNumber(long) {
    if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return long.toNumber();
}
const registerLong = () => {
    const backup = __m0.util.Long;
    __m0.util.Long = Long;
    __m0.configure();
    return () => {
        __m0.util.Long = backup;
        __m0.configure();
    };
};
